import HeroSection from '../../sections/HeroSection/HeroSection';
import { ThemeProvider } from 'styled-components';
import theme from '../../global/theme';
import CTASection from '../../sections/CalltoActionSection/CalltoActionSection';
import { GlobalStyle } from '../../global/global';
import {
    Box,
    Flex,
    Text,
    Image,
    UnorderedList,
    ListItem,
    Link,
    List,
    ListIcon,
    Show,
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalCloseButton,
    ModalBody,
    Button,
    useDisclosure,
    Grid,
    Heading,
    AspectRatio,
} from '@chakra-ui/react';
import FAQ from '../../sections/Faq/Faq';
import ChakraTilesSection from '../../sections/ChakraTilesSection/ChakraTilesSection';
import WhyService from '../../sections/WhyService/WhyService';
import BenefitsSectionWithImage from '../../sections/BenefitsSectionWithImage/BenefitsSectionWithImage';
import ExtendedTabsSection from '../../sections/ExtendedTabsSection/ExtendedTabsSection';
import { CheckIcon, AddIcon, PlusSquareIcon } from '@chakra-ui/icons';
import { ButtonContainer } from '../../sections/MigrationSection/styles';
import StyledButton from '../../components/Button/Button';
import ContactSection from '../../sections/ContactSection/ContactSection';
import ContentImage from '../../sections/ContentImageSection/ContentImageSection';
import FormSection from '../../sections/FormSection/FormSection';
import TilesSection from '../../sections/TilesSection/TilesSection';
import SectionWithPlusTick from '../../sections/SectionWithPlusTick/SectionWithPlusTick';
import MigrationSection from '../../sections/MigrationSection/MigrationSection';

interface Props {}

const heroImage = {
    url: 'https://www.idosell.com/panel/file-gate.php?id=611121&ext=.jpeg',
    alt: 'Zdjęcie wyróżniające w hero - social media',
};

export default function SocialMediaPageComponent(props: Props) {
    return (
        <ThemeProvider theme={theme}>
            <GlobalStyle $whiteColor />
            <HeroSection
                title="Integracje z social mediami w IdoSell"
                subTitle="Połącz swój sklep IdoSell z Facebookiem, Instagramem czy TikTokiem. Dotrzyj do milionów klientów i zwiększ zasięgi oraz sprzedaż."
                image={heroImage}
                paddingDesktop="75px 0"
                gap="0"
            />
            <div className="homepage containerIdosellPages">
                <TilesSection
                    title={'Wykorzystaj potencjał Facebooka i promuj swój sklep'}
                    tiles={[
                        {
                            title: 'Ogromna sieć reklamowa',
                            content:
                                'Facebook daje Ci dostęp do drugiej największej sieci reklamowej na świecie. Stwórz spersonalizowane reklamy i przyciągnij klientów do swojego sklepu.',
                        },
                        {
                            title: '20 mln użytkowników w Polsce',
                            content:
                                'Facebook to najpopularniejszy kanał mediów społecznościowych w Polsce. Wśród jego użytkowników są twoi potencjalni klienci.',
                        },
                        {
                            title: 'Zaangażowana społeczność',
                            content:
                                'Wykorzystaj funkcje, które aktywizują klientów w rozwój twojego biznesu. Pozwól im publikować komentarze i opinie, a także tworzyć grupy fanów Twojego sklepu.',
                        },
                    ]}
                />
                <Box
                    p={{ base: '20px 0', lg: '50px 0 112.5px 0' }}
                    display={'flex'}
                    flexDirection={'column'}
                    gap={'50px'}
                    position={'relative'}
                >
                    <Box>
                        <Box
                            display={'flex'}
                            gap={'30px'}
                            alignItems={'center'}
                            flexDir={{ base: 'column', lg: 'row' }}
                        >
                            <Box width={{ base: '100%', lg: '50%' }}>
                                <Show above="lg">
                                    <Image
                                        src="https://www.idosell.com/panel/file-gate.php?id=611122&ext=.png"
                                        alt=""
                                    ></Image>
                                </Show>
                                <Show below="lg">
                                    <Image
                                        src="https://www.idosell.com/panel/file-gate.php?id=611123&ext=.png"
                                        alt=""
                                    ></Image>
                                </Show>
                            </Box>
                            <Box
                                display={'flex'}
                                flexDir={'column'}
                                justifyContent={'start'}
                                alignItems={'start'}
                                width={{ base: '100%', lg: '50%' }}
                                padding={'30px'}
                            >
                                <Text
                                    fontSize={'34px'}
                                    lineHeight={'1.5'}
                                    fontWeight={'600'}
                                    color={'#1AAC7A'}
                                    mb="30px"
                                >
                                    Facebook for IdoSell to integracja, która zwiększa zasięgi i
                                    sprzedaż
                                </Text>
                                <List
                                    spacing={'15px'}
                                    fontSize={'18px'}
                                    lineHeight={'27px'}
                                    color={'#171717'}
                                    mb={'45px'}
                                >
                                    <ListItem display={'flex'}>
                                        <Box mr={'30px'} mt={'5px'}>
                                            <svg
                                                width="20"
                                                height="26"
                                                viewBox="0 0 20 26"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <g clip-path="url(#clip0_8_2627)">
                                                    <path
                                                        fill-rule="evenodd"
                                                        clip-rule="evenodd"
                                                        d="M12 12.5V5.5H9L9 12.5H2V15.5H9L9 22.5H12V15.5H19V12.5H12Z"
                                                        fill="#1AAC7A"
                                                    />
                                                </g>
                                                <defs>
                                                    <clipPath id="clip0_8_2627">
                                                        <rect
                                                            width="20"
                                                            height="20"
                                                            fill="white"
                                                            transform="translate(0 5.5)"
                                                        />
                                                    </clipPath>
                                                </defs>
                                            </svg>
                                        </Box>

                                        <Box flex={'1'}>
                                            <Text
                                                color={''}
                                                fontSize={'21px'}
                                                lineHeight={'1.5'}
                                                fontWeight={'600'}
                                                mb="5px"
                                            >
                                                Zwiększ rozpoznawalność marki
                                            </Text>
                                            <Text fontSize={'16px'} lineHeight={'1.5'} mb="5px">
                                                Uruchom integrację i zwiększ rozpoznawalność swojej
                                                marki. Zyskaj dostęp do drugiej największej sieci
                                                reklamowej na świecie.
                                            </Text>
                                        </Box>
                                    </ListItem>
                                    <ListItem display={'flex'}>
                                        <Box mr={'30px'} mt={'5px'}>
                                            <svg
                                                width="20"
                                                height="26"
                                                viewBox="0 0 20 26"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <g clip-path="url(#clip0_8_2627)">
                                                    <path
                                                        fill-rule="evenodd"
                                                        clip-rule="evenodd"
                                                        d="M12 12.5V5.5H9L9 12.5H2V15.5H9L9 22.5H12V15.5H19V12.5H12Z"
                                                        fill="#1AAC7A"
                                                    />
                                                </g>
                                                <defs>
                                                    <clipPath id="clip0_8_2627">
                                                        <rect
                                                            width="20"
                                                            height="20"
                                                            fill="white"
                                                            transform="translate(0 5.5)"
                                                        />
                                                    </clipPath>
                                                </defs>
                                            </svg>
                                        </Box>
                                        <Box flex={'1'}>
                                            <Text
                                                fontSize={'21px'}
                                                lineHeight={'1.5'}
                                                fontWeight={'600'}
                                                mb="5px"
                                            >
                                                Łatwo zarządzaj reklamami
                                            </Text>
                                            <Text fontSize={'16px'} lineHeight={'1.5'} mb="5px">
                                                Włącz integrację i stwórz zoptymalizowane kampanie
                                                reklamowe bezpośrednio z poziomu Menedżera Firmy.
                                            </Text>
                                        </Box>
                                    </ListItem>
                                    <ListItem display={'flex'}>
                                        <Box mr={'30px'} mt={'5px'}>
                                            <svg
                                                width="20"
                                                height="26"
                                                viewBox="0 0 20 26"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <g clip-path="url(#clip0_8_2627)">
                                                    <path
                                                        fill-rule="evenodd"
                                                        clip-rule="evenodd"
                                                        d="M12 12.5V5.5H9L9 12.5H2V15.5H9L9 22.5H12V15.5H19V12.5H12Z"
                                                        fill="#1AAC7A"
                                                    />
                                                </g>
                                                <defs>
                                                    <clipPath id="clip0_8_2627">
                                                        <rect
                                                            width="20"
                                                            height="20"
                                                            fill="white"
                                                            transform="translate(0 5.5)"
                                                        />
                                                    </clipPath>
                                                </defs>
                                            </svg>
                                        </Box>
                                        <Box flex={'1'}>
                                            <Text
                                                fontSize={'21px'}
                                                lineHeight={'1.5'}
                                                fontWeight={'600'}
                                                mb="5px"
                                            >
                                                Omiń ograniczenia AdBlocków
                                            </Text>
                                            <Text fontSize={'16px'} lineHeight={'1.5'} mb="5px">
                                                Dane są przesyłane bezpośrednio z serwera, a nie
                                                przez przeglądarkę.
                                            </Text>
                                        </Box>
                                    </ListItem>
                                </List>
                                <Link
                                    href="https://pomoc.idosell.com/marketing-i-promocje/integracja-z-facebookiem/facebook-product-ads-i-catalog-facebook"
                                    background={'#171717'}
                                    color={'white'}
                                    padding={'12px 30px'}
                                    fontSize={'16px'}
                                    fontWeight={'600'}
                                    display={'flex'}
                                    alignItems={'center'}
                                    gap={'10px'}
                                    margin={'0 auto'}
                                    _hover={{
                                        underline: 'none',
                                        background: 'rgba(11, 113, 83, 0.5)',
                                    }}
                                >
                                    Włącz integrację z Facebookiem
                                    <svg
                                        width="9"
                                        height="14"
                                        viewBox="0 0 9 14"
                                        fill="white"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path d="M0 13.6H2.70588L8.4 6.98565L2.70588 0.400024H0L5.69412 6.98565L0 13.6Z" />
                                    </svg>
                                </Link>
                            </Box>
                        </Box>
                    </Box>
                </Box>
                <SectionWithPlusTick
                    alignItems={'center'}
                    display={'flex'}
                    flexDirection={'column'}
                    background={'#1AAC7A'}
                    imagePosition={'right'}
                    p={'50px 15px'}
                    imageResponsive={{
                        base: {
                            url: 'https://www.idosell.com/panel/file-gate.php?id=611125&ext=.webp',
                            alt: 'Zdjęcie bannerowe - facebook mobile',
                        },
                        md: {
                            url: 'https://www.idosell.com/panel/file-gate.php?id=611124&ext=.webp',
                            alt: 'Zdjęcie bannerowe - facebook',
                        },
                    }}
                    ctaButton={{
                        label: 'Włącz Meta Pixel',
                        href: 'https://pomoc.idosell.com/marketing-i-promocje/integracja-z-facebookiem/meta-pixel',
                    }}
                    type="tick"
                    tickItem={[
                        {
                            title: 'Śledź konwersję i monitoruj interakcje oraz zachowania klientów w Twoim sklepie',
                        },
                        {
                            title: 'Optymalizuj reklamy dynamiczne. Przełoży się to na większą skuteczność Twoich reklam.',
                        },
                        {
                            title: 'Remarketing – przypomnij klientowi o produkcie, który oglądał w Twoim sklepie, ale nie zdecydował się na zakup.',
                        },
                        {
                            title: 'Twórz grupy odbiorców – dzięki Pixelowi dowiesz się, którzy klienci interesują się Twoimi produktami. Wykorzystaj te dane do stworzenia skutecznej reklamy.',
                        },
                    ]}
                />
                <Box
                    p={{ base: '20px 0', lg: '50px 0 100px 0' }}
                    display={'flex'}
                    flexDirection={'column'}
                    gap={'50px'}
                    position={'relative'}
                >
                    <Box>
                        <Flex
                            flexDir={'column'}
                            alignItems={'center'}
                            marginBottom={{ base: '35px', lg: '50px' }}
                        >
                            <Text
                                fontSize={'34px'}
                                lineHeight={'1.5'}
                                fontWeight={'600'}
                                color={'#171717'}
                                mb="10px"
                            >
                                Wyświetlaj zdjęcia z Instagrama w swoim sklepie IdoSell 
                            </Text>
                            <Text fontSize={'18px'} lineHeight={'auto'} color={'#171717'}>
                                Połącz w prosty sposób swój sklep internetowy z Instagramem i
                                dotrzyj do całkowicie nowej bazy potencjalnych klientów.
                            </Text>
                        </Flex>
                        <Box
                            display={'flex'}
                            gap={'30px'}
                            alignItems={'center'}
                            flexDir={{ base: 'column', lg: 'row' }}
                        >
                            <Box width={{ base: '100%', lg: '50%' }}>
                                <Show above="lg">
                                    <Image
                                        src="https://www.idosell.com/panel/file-gate.php?id=611126&ext=.png"
                                        alt=""
                                    ></Image>
                                </Show>
                                <Show below="lg">
                                    <Image
                                        src="https://www.idosell.com/panel/file-gate.php?id=611126&ext=.png"
                                        alt=""
                                    ></Image>
                                </Show>
                            </Box>
                            <Box
                                display={'flex'}
                                flexDir={'column'}
                                alignItems={'start'}
                                justifyContent={'start'}
                                width={{ base: '100%', lg: '50%' }}
                                padding={'30ox'}
                            >
                                <List
                                    spacing={'15px'}
                                    fontSize={'18px'}
                                    lineHeight={'27px'}
                                    color={'#171717'}
                                    mb={'30px'}
                                >
                                    <ListItem display={'flex'}>
                                        <Box mr={'30px'} mt={'5px'}>
                                            <svg
                                                width="20"
                                                height="25"
                                                viewBox="0 0 20 25"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <path
                                                    fill-rule="evenodd"
                                                    clip-rule="evenodd"
                                                    d="M11.058 17.8922L11.0655 17.8996L8.94418 20.021L3.68945 14.7662L5.81077 12.6449L8.9367 15.7708L16.5083 8.19922L18.6296 10.3205L11.058 17.8922Z"
                                                    fill="#1AAC7A"
                                                />
                                            </svg>
                                        </Box>

                                        <Box flex={'1'}>
                                            <Text
                                                color={''}
                                                fontSize={'21px'}
                                                lineHeight={'1.5'}
                                                fontWeight={'600'}
                                            >
                                                Stwórz unikalny wizerunek marki
                                            </Text>
                                        </Box>
                                    </ListItem>
                                    <ListItem display={'flex'}>
                                        <Box mr={'30px'} mt={'5px'}>
                                            <svg
                                                width="20"
                                                height="25"
                                                viewBox="0 0 20 25"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <path
                                                    fill-rule="evenodd"
                                                    clip-rule="evenodd"
                                                    d="M11.058 17.8922L11.0655 17.8996L8.94418 20.021L3.68945 14.7662L5.81077 12.6449L8.9367 15.7708L16.5083 8.19922L18.6296 10.3205L11.058 17.8922Z"
                                                    fill="#1AAC7A"
                                                />
                                            </svg>
                                        </Box>

                                        <Box flex={'1'}>
                                            <Text
                                                color={''}
                                                fontSize={'21px'}
                                                lineHeight={'1.5'}
                                                fontWeight={'600'}
                                            >
                                                Wyświetlaj zdjęcia z Instagrama na stronie swojego
                                                sklepu
                                            </Text>
                                        </Box>
                                    </ListItem>
                                    <ListItem display={'flex'}>
                                        <Box mr={'30px'} mt={'5px'}>
                                            <svg
                                                width="20"
                                                height="25"
                                                viewBox="0 0 20 25"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <path
                                                    fill-rule="evenodd"
                                                    clip-rule="evenodd"
                                                    d="M11.058 17.8922L11.0655 17.8996L8.94418 20.021L3.68945 14.7662L5.81077 12.6449L8.9367 15.7708L16.5083 8.19922L18.6296 10.3205L11.058 17.8922Z"
                                                    fill="#1AAC7A"
                                                />
                                            </svg>
                                        </Box>

                                        <Box flex={'1'}>
                                            <Text
                                                color={''}
                                                fontSize={'21px'}
                                                lineHeight={'1.5'}
                                                fontWeight={'600'}
                                            >
                                                Śledź konwersję i zachowania użytkowników
                                            </Text>
                                        </Box>
                                    </ListItem>
                                    <ListItem display={'flex'}>
                                        <Box mr={'30px'} mt={'5px'}>
                                            <svg
                                                width="20"
                                                height="25"
                                                viewBox="0 0 20 25"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <path
                                                    fill-rule="evenodd"
                                                    clip-rule="evenodd"
                                                    d="M11.058 17.8922L11.0655 17.8996L8.94418 20.021L3.68945 14.7662L5.81077 12.6449L8.9367 15.7708L16.5083 8.19922L18.6296 10.3205L11.058 17.8922Z"
                                                    fill="#1AAC7A"
                                                />
                                            </svg>
                                        </Box>
                                        <Box flex={'1'}>
                                            <Text
                                                fontSize={'21px'}
                                                lineHeight={'1.5'}
                                                fontWeight={'600'}
                                            >
                                                Twórz precyzyjne i skuteczne reklamy dynamiczne
                                            </Text>
                                        </Box>
                                    </ListItem>
                                    <ListItem display={'flex'}>
                                        <Box mr={'30px'} mt={'5px'}>
                                            <svg
                                                width="20"
                                                height="25"
                                                viewBox="0 0 20 25"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <path
                                                    fill-rule="evenodd"
                                                    clip-rule="evenodd"
                                                    d="M11.058 17.8922L11.0655 17.8996L8.94418 20.021L3.68945 14.7662L5.81077 12.6449L8.9367 15.7708L16.5083 8.19922L18.6296 10.3205L11.058 17.8922Z"
                                                    fill="#1AAC7A"
                                                />
                                            </svg>
                                        </Box>
                                        <Box flex={'1'}>
                                            <Text
                                                fontSize={'21px'}
                                                lineHeight={'1.5'}
                                                fontWeight={'600'}
                                            >
                                                Aktywizuj klientów i wyświetlaj ich zdjęcia
                                            </Text>
                                        </Box>
                                    </ListItem>
                                </List>
                                <Link
                                    href="https://www.idosell.com/pl/blog/integracja-idosell-photoslurp-1235327195"
                                    background={'#171717'}
                                    color={'white'}
                                    padding={'12px 30px'}
                                    fontSize={'16px'}
                                    fontWeight={'600'}
                                    display={'flex'}
                                    alignItems={'center'}
                                    gap={'10px'}
                                    _hover={{
                                        underline: 'none',
                                        background: 'rgba(11, 113, 83, 0.5)',
                                    }}
                                >
                                    Dowiedz się więcej
                                    <svg
                                        width="9"
                                        height="14"
                                        viewBox="0 0 9 14"
                                        fill="white"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path d="M0 13.6H2.70588L8.4 6.98565L2.70588 0.400024H0L5.69412 6.98565L0 13.6Z" />
                                    </svg>
                                </Link>
                            </Box>
                        </Box>
                    </Box>
                </Box>
                <MigrationSection
                    image={{
                        url: 'https://www.iai-system.com/panel/file-gate.php?id=612100&ext=.jpg',
                    }}
                    boxSide="right"
                    title="Połącz sklep z TikTokiem i dotrzyj do milionów klientów"
                    subtitle="Dzięki naszym elastycznym narzędziom możesz bez problemu połączyć swój sklep z TikTokiem i skutecznie zarządzać kampaniami."
                    ctaButton={{
                        title: 'Połącz sklep z TikTokiem',
                        href: 'https://pomoc.idosell.com/marketing-i-promocje/narzedzia-marketingowe/integracja-z-tiktok',
                        variant: 'default',
                    }}
                    position={'relative'}
                    _before={{
                        base: {
                            content: '""',
                            position: 'absolute',
                            height: '100%',
                            top: 0,
                            width: '100vw',
                            marginLeft: '50%',
                            left: '-50vw',
                            zIndex: -2,
                            backgroundColor: '#1AAC7A', // Replace with your theme color reference
                        },
                        lg: {
                            display: 'none',
                        },
                    }}
                >
                    <Text mb="30px">
                        Oferujemy rozwiązania, które umożliwiają konfigurację zewnętrznych połączeń,
                        monitorowanie efektów działań marketingowych oraz optymalizację kampanii.
                        Wykorzystaj pełen potencjał TikToka i dotrzyj do nowych klientów!
                    </Text>
                </MigrationSection>
                <Box
                    p={{ base: '20px 0', lg: '50px 0 112.5px 0' }}
                    display={'flex'}
                    flexDirection={'column'}
                    gap={'50px'}
                    position={'relative'}
                >
                    <Box>
                        <Box
                            display={'flex'}
                            gap={'30px'}
                            alignItems={'center'}
                            flexDir={{ base: 'column', lg: 'row' }}
                        >
                            <Box
                                display={'flex'}
                                justifyContent={'start'}
                                alignItems={'start'}
                                flexDir={'column'}
                                width={{ base: '100%', lg: '50%' }}
                                padding={'50px'}
                            >
                                <Text
                                    fontSize={'34px'}
                                    lineHeight={'1.5'}
                                    fontWeight={'600'}
                                    color={'#171717'}
                                    mb="15px"
                                >
                                    Wypromuj sklep z Traffic Trends
                                </Text>
                                <Text color={'#171717'} fontSize={'18px'} marginBottom={'45px'}>
                                    Zleć prowadzenie reklam Facebook Ads i Instagram Ads
                                    specjalistom z Traffic Trends. Realizują oni setki kampanii dla
                                    sklepów z różnych branż. Dzięki wieloletniemu doświadczeniu
                                    doskonale wiedzą, jak skutecznie generować ruch i sprzedaż.
                                </Text>
                                <Link
                                    href="https://www.idosell.com/pl/marketing-sklepu-internetowego-z-traffic-trends/meta-ads/"
                                    background={'#171717'}
                                    color={'white'}
                                    padding={'12px 30px'}
                                    fontSize={'16px'}
                                    fontWeight={'600'}
                                    display={'flex'}
                                    alignItems={'center'}
                                    gap={'10px'}
                                    _hover={{
                                        underline: 'none',
                                        background: 'rgba(11, 113, 83, 0.5)',
                                    }}
                                >
                                    Dowiedz się więcej
                                    <svg
                                        width="9"
                                        height="14"
                                        viewBox="0 0 9 14"
                                        fill="white"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path d="M0 13.6H2.70588L8.4 6.98565L2.70588 0.400024H0L5.69412 6.98565L0 13.6Z" />
                                    </svg>
                                </Link>
                            </Box>
                            <Box
                                justifyContent={'center'}
                                alignItems={'center'}
                                width={{ base: '100%', lg: '50%' }}
                                display={'flex'}
                            >
                                <Show above="lg">
                                    <Image
                                        src="https://www.idosell.com/panel/file-gate.php?id=611127&ext=.png"
                                        alt=""
                                    ></Image>
                                </Show>
                                <Show below="lg">
                                    <Image
                                        src="https://www.idosell.com/panel/file-gate.php?id=611127&ext=.png"
                                        alt=""
                                    ></Image>
                                </Show>
                            </Box>
                        </Box>
                    </Box>
                </Box>
                <ContactSection mb="50px" />
            </div>
        </ThemeProvider>
    );
}
